import UserGroupInforCard from '../../User/UserGroupInforCard';

const Loader = ({ data }) => {
  return (
    <div>
      {data?.map(item => (
        <UserGroupInforCard key={item.id} duration={3000} loading={true} name={item.name} id={item._id} email={item.email} onClick={() => {}} />
      ))}
    </div>
  );
};

export default Loader;
